// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ui-meet-3d-home-content .ui.icon.message.call-to-action {\n  background-color: #3883A8;\n  color: white;\n}\n.ui-meet-3d-home-content .ui.icon.message.call-to-action .icon {\n  opacity: 1;\n  font-size: 8em;\n  margin-right: 0.15em;\n}\n.ui-meet-3d-home-content .ui.basic.button {\n  background-color: white !important;\n  color: #3883A8 !important;\n  margin-top: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
